export default __webpack_public_path__ + "static/media/book-1.4959ccb9.jpeg";